<template>
    <div>
        <b-row>
            <b-col>
                <h5>
                    <span
                        @click="hasHistory()
                        ? $router.go(-1)
                        : $router.push('/')"
                        class="button-come-back mr-2"><i class="fas fa-angle-left"></i>
                    </span> Отделы
                </h5>
            </b-col>
        </b-row>
        <div class="mt-4 position-relative">
            <b-card no-body class="bdr-tabs">
                <b-tabs card>
                    <b-tab 
                        v-for="(dep, d_key) in departments"
                        :title="dep.name"
                        :key="d_key"
                    >
                        <b-card-text>
                            <DepartmentAnalytic
                                :departmentId="dep.id"
                                :key="`department_${d_key}`"
                            />
                            
                            <!-- Бонусные условия для департаментов логистики и ТО/ВЭД -->
                            <div v-if="isLogisticsDepartment(dep.id) || isTODepartment(dep.id)" class="mt-4">
                                <DepartmentBonusConditions
                                    :departmentId="dep.id"
                                    :key="`bonus_${d_key}`"
                                />
                            </div>
                        </b-card-text>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
    import DepartmentAnalytic from '@components/departments/DepartmentAnalytic';
    import DepartmentBonusConditions from '@components/departments/DepartmentBonusConditions';

    export default {
        data() {
            return {
                departments: {
                    1: {
                        id: 1,
                        name: 'Отдел Продаж'
                    },
                    2: {
                        id: 2,
                        name: 'Отдел ВЭД'
                    },
                    3: {
                        id: 3,
                        name: 'Отдел Логистики'
                    }
                },
            }
        },
        components: {
            DepartmentAnalytic,
            DepartmentBonusConditions
        },
        methods: {
            hasHistory () {
                return window.history.length > 2
            },
            isLogisticsDepartment(departmentId) {
                // Проверяем, является ли департамент логистическим
                // В данном случае ID 3 соответствует "Отдел Логистики"
                return departmentId === 3;
            },
            isTODepartment(departmentId) {
                // Проверяем, является ли департамент ТО/ВЭД
                // В данном случае ID 2 соответствует "Отдел ВЭД" (ТО)
                return departmentId === 2;
            }
        }
    }
</script>
<style scoped>

</style>